/* eslint-disable react-hooks/rules-of-hooks */
import React, { useState } from 'react'
import { useForm } from "react-hook-form"

import './PanelCreate.scss'

import Menu from '../../../components/Menu'

import { post } from '../../../services/http'
import { notify } from '../../../components/Toast'

import { ToastContainer } from 'react-toastify'
import { useNavigate } from 'react-router-dom'

export default function index() {
  const navigate = useNavigate()
  document.title = 'ایجاد رستوران یا کافی شاپ'

  const token = localStorage.getItem('token')

  const { register, handleSubmit } = useForm()
  
  const [timePartCount, setTimePartCount] = useState(2)
  const [timePart, setTimePart] = useState([{ id : 1 }])
  const [file, setFile] = useState()
  const [clickButton, setClickButton] = useState(false)
  
  const timeHandler = () => {
    setTimePartCount(timePartCount + 1)
    setTimePart(oldArray => [...oldArray, { id : timePartCount}])
  }

  const onSubmit = (data, e) => {
    setClickButton(true)

    e.preventDefault()
    let count = 1
    const timesArray = []
    while(count < timePartCount) {
      const item =  {
        day: data['days' + count],
        time: data['time' + count]
      }
      timesArray.push(item)
      count++
    }
    let formData = new FormData()
    formData.append('logo', file)
    formData.append('name', data.name)
    formData.append('description', data.description)
    formData.append('address', data.address)
    formData.append('tell', data.tell)
    formData.append('email', data.email)
    formData.append('about', data.about)
    formData.append('times', JSON.stringify(timesArray))
    formData.append('instagram', data.instagram)
    formData.append('tellegram', data.tellegram)
    formData.append('twitter', data.twitter)
    formData.append('whatsapp', data.whatsapp)

    const config = {
      headers: {
        'content-type': 'multipart/form-data'
      }
    } 
    post(`/api/admin/shops?token=${token}`, formData, config).then(response => {
      notify('success', response.data.messageFa)
      setTimeout(() => {
        navigate('/resturants')
      }, 2000)
    }).catch(error => {
      setClickButton(false)
      if (error) {
        notify('error', error)
      }
      notify('error', 'خطا در ارسال اطلاعات')
    })
  }

  return (
    <main id='panel'>
      <ToastContainer rtl />
      <Menu page={'resturant'} badgeCountDashboard={0} badgeCountOrder={0} />
      <article className='panelBody'>
        <section className='panelContent'>
          <div className='title'>
            <div className='right'>
              <div className='text'>
                ایجاد رستوران‌ها یا کافی شاپ‌ها
              </div>
            </div>

            <div className='left'>
            </div>
          </div>

          <form className='form' onSubmit={handleSubmit(onSubmit)}>
            <div className='title'>
              * برای ایجاد رستوران یا کافی شاپ خود لطفا تمامی فیلد های مشخص شده را پر کنید.
            </div>
            <div className='lineTitle'>
              <hr />
              اطلاعات رستوران
              <hr />
            </div>
            <div className='row'>
              <div className='column'>
                <label htmlFor='resturantName'>نام رستوران * :</label>
                <input id='resturantName' {...register("name", { required: true, minLength: 5 })} type='text' placeholder='فست فود تبریز' />
                <small id='resturantNameAlert'>نام رستوران باید وارد شود</small>
              </div>
              <div className='column'>
                <label htmlFor='resturantDetails'>توضیحات * :</label>
                <input id='resturantDetails' {...register("description", { required: true, minLength: 5 })} type='text' placeholder='شعبه ...' />
                <small id='resturantDetailsAlert'>توضیحات باید وارد شود</small>
              </div>
            </div>
            <div className='row'>
              <div className='column'>
                <label htmlFor='resturantAddress'>آدرس * :</label>
                <input id='resturantAddress' {...register("address", { required: true, minLength: 5 })} type='text' placeholder='شهر - خیابان - ...' />
                <small id='resturantAddressAlert'>آدرس باید وارد شود</small>
              </div>
              <div className='column'>
                <label htmlFor='resturantTell'>تلفن * :</label>
                <input id='resturantTell' {...register("tell", { required: true, minLength: 5 })} type='tel' placeholder='04...' />
                <small id='resturantTellAlert'>تلفن باید وارد شود</small>
              </div>
            </div>
            <div className='row'>
              <div className='column'>
                <label htmlFor='resturantEmail'>ایمیل * :</label>
                <input id='resturantEmail' {...register("email", { required: true, minLength: 5 })} type='email' placeholder='info@...' />
                <small id='resturantAlert'>ایمیل باید وارد شود</small>
              </div>
            </div>
            <div className='row'>
              <div className='column textarea'>
                <label htmlFor='resturantEmail'>درباره * :</label>
                <textarea id='resturantEmail' {...register("about", { required: true, minLength: 5 })} rows={5} placeholder='سال شروع ...' />
                <small id='resturantAlert'>درباره ما باید وارد شود</small>
              </div>
            </div>
            <div className='lineTitle'>
              <hr />
              ساعات کاری مجموعه
              <hr />
            </div>
            {timePart.map((item, index) => (
              <div className='row' key={index} id={item.id}>
                <div className='column'>
                  <label htmlFor='resturantDay'>روز کاری مجموعه * :</label>
                  <input id='resturantDay' {...register(`days${item.id}`, { required: true, minLength: 3 })} type='text' placeholder='از شنبه تا چهارشنبه' />
                  <small id='resturantDayAlert'>روز کاری مجموعه باید وارد شود</small>
                </div>
                <div className='column'>
                  <label htmlFor='resturantTime'>ساعت کاری مجموعه * :</label>
                  <input id='resturantTime' {...register(`time${item.id}`, { required: true, minLength: 3 })} type='text' placeholder='از ساعت 11 تا 1 بامداد' />
                  <small id='resturantTimeAlert'>ساعت کاری مجموعه باید وارد شود</small>
                </div>
              </div>
            ))}
            <div className="row">
              <div className="add" onClick={timeHandler}>
                +
              </div>
            </div>
            <div className='row'>
              <div className='column'>
                <label htmlFor='logo'>لوگو رستوران :</label>
                <input id='logo' onChange={e => {
                  const fileSelect = e.target.files[0]
                  setFile(fileSelect)
                }} type='file' />
                <small id='resturantAlert'>لوگو باید انتخاب شود</small>
              </div>
            </div>
            <div className='lineTitle'>
              <hr />
              شبکه های اجتماعی
              <hr />
            </div>
            <div className='row'>
              <div className='column'>
                <label htmlFor='resturantInstagram'>اینستاگرام :</label>
                <input id='resturantInstagram' {...register("instagram", { required: true })} type='url' placeholder='https://www.instagram.com/...' />
              </div>
              <div className='column'>
                <label htmlFor='resturantTelegram'>تلگرام :</label>
                <input id='resturantTelegram' {...register("tellegram", { required: true })} type='url' placeholder='https://telegram.org/...' />
              </div>
            </div>
            <div className='row'>
              <div className='column'>
                <label htmlFor='resturantInstagram'>توئیتر :</label>
                <input id='resturantInstagram' {...register("twitter", { required: true })} type='url' placeholder='https://twitter.com/...' />
              </div>
              <div className='column'>
                <label htmlFor='resturantTelegram'>واتس اپ :</label>
                <input id='resturantTelegram' {...register("whatsapp", { required: true })} type='url' placeholder='https://whatsapp.com/...' />
              </div>
            </div>
            <button className='createButton' type='submit' style={clickButton ? { backgroundColor: 'gray' } : {}} disabled={clickButton ? true : false}>{clickButton ? 'در حال آپلود ...' : 'ایجاد رستوران یا کافی شاپ'}</button>
          </form>
          <div className='copyright'>
            © تمامی حقوق برای <a href='https://ibills.ir'>ibills</a> محفوظ است. طراحی و توسعه توسط <a href='https://ham-team.ir'>هم تیم</a>
          </div>
        </section>
      </article>
    </main>
  )
}
